/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, useRef } from 'react'
import { Modal, Spin } from 'antd'
import ESuiteDetailsForm from './eSuiteForm'

const ESuiteModal = ({
  hide,
  data = {},
  updateTask,
  createTask,
  isLoading = false,
  companyOption,
  setError,
}) => {
  const processing = isLoading
  const { isNew = false, resetPass = false } = data
  const [baseData, setBaseData] = useState(
    isNew ? { ...data, market: 'eMKT' } : data
  )
  // const [err, setErr] = useState()
  const eSuiteFormRef = useRef()

  const onOk = () => {
    eSuiteFormRef.current &&
      eSuiteFormRef.current.validateFields(error => {
        if (error) {
          // error
        } else {
          if (isNew) {
            createTask({ ...baseData, resetPass: false }).fork(setError, hide)
          } else if (resetPass) {
            updateTask({ ...baseData, resetPass: false }).fork(setError, hide)
          } else {
            updateTask({
              ...baseData,
              password: data.password,
              resetPass: false,
            }).fork(setError, hide)
          }
        }
      })
  }

  return (
    <Modal
      title={isNew ? 'Create New' : !resetPass ? 'Update' : 'Update Password'}
      width="70vw"
      visible
      onOk={onOk}
      okText="Save"
      onCancel={hide}
      centered
      bodyStyle={{ maxHeight: '70vh' }}
      maskClosable={false}
      okButtonProps={{ loading: processing }}
      cancelButtonProps={{ loading: processing }}
    >
      <Spin spinning={processing}>
        <ESuiteDetailsForm
          isNew={isNew}
          resetPass={resetPass}
          eSuite={baseData}
          editData={setBaseData}
          eSuiteFormRef={eSuiteFormRef}
          companyOption={companyOption}
          setError={setError}
        />
      </Spin>
    </Modal>
  )
}

export default ESuiteModal
